import { LocaleType, LOCALES } from '@benzinga/translate';
import { KoreaConfig } from '../config/global/kr/config';
import { JapanConfig } from '../config/global/jp/config';
import { SpainConfig } from '../config/global/es/config';
import { ItalyConfig } from '../config/global/it/config';
import { FranceConfig } from '../config/global/fr/config';
import { GlobalNavigationConfig } from '../entities';

export const getGlobalConfigByLocale = (locale: LocaleType): GlobalNavigationConfig | null => {
  const configs: Partial<Record<LocaleType, GlobalNavigationConfig>> = {
    [LOCALES.KO]: KoreaConfig,
    [LOCALES.JA]: JapanConfig,
    [LOCALES.ES]: SpainConfig,
    [LOCALES.IT]: ItalyConfig,
    [LOCALES.FR]: FranceConfig,
  };

  return configs[locale] || null;
};

// Global navigation config is resolved by locale only (the india domain path was removed with BZ India — #16084).
export const getGlobalConfig = (_host: string, locale: LocaleType): GlobalNavigationConfig | null =>
  getGlobalConfigByLocale(locale);
